module.exports = __webpack_public_path__ + "static/img/6961_phase_function_Paper_PointsHejduk_Prediction.8684d9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6961_phase_function_Paper_PointsHejduk_Prediction.png
// module id = Bv93
// module chunks = 0